// USA
export const locale = {
  lang: 'en',
  data: {
    TRANSLATOR: {
      SELECT: 'Select your language',
    },
    MENU: {
      NEW: 'new',
      ACTIONS: 'Actions',
      CREATE_POST: 'Create New Post',
      PAGES: 'Pages',
      FEATURES: 'Features',
      APPS: 'Apps',
      DASHBOARD: 'Dashboard',
      DATAHISTORY: 'Emission Data History',
      SUPPLIERS: 'Suppliers',
    },
    AUTH: {
      GENERAL: {
        OR: 'Or',
        SUBMIT_BUTTON: 'Submit',
        NO_ACCOUNT: "Don't have an account?",
        SIGNUP_BUTTON: 'Sign Up',
        FORGOT_BUTTON: 'Forgot Password',
        BACK_BUTTON: 'Back',
        PRIVACY: 'Privacy',
        LEGAL: 'Legal',
        CONTACT: 'Contact',
        PLEASE_WAIT: 'Please wait...',
        POWERED_BY: 'Powered by Carbon Gate',
      },
      LOGIN: {
        TITLE: 'Login Account',
        BUTTON: 'Sign In',
      },
      FORGOT: {
        TITLE: 'Forgotten Password?',
        DESC: 'Enter your email to reset your password',
        SUCCESS: 'Your account has been successfully reset.',
        SEND_BUTTON: 'Send',
        SENT_INFO: 'Password reset request sent. Please check your email.',
      },
      FORGOT_PASSWORD_SUCCESS: {
        TITLE: 'Forgot Password',
        INFO: 'We have sent the password recovery link to your email address.',
        LOGIN_HINT: 'Please login after resetting your password.',
        LOGIN_BUTTON: 'Login',
      },
      CONFIRM_EMAIL: {
        TITLE: 'Confirm Account',
        LOADING: 'Confirming your account, please wait...',
        SUCCESS: 'Your account is successfully confirmed.',
      },
      CREATE_PASSWORD: {
        TITLE: 'Create Password',
        NEW_PASSWORD: 'New Password',
        CONFIRM_PASSWORD: 'Confirm Password',
        BUTTON: 'Create Password',
        STRONG_PASSWORD_HINT:
          'Password must be at least 8 characters and include uppercase, lowercase, number, and special character.',
      },
      REGISTER: {
        TITLE: 'Sign Up',
        DESC: 'Enter your details to create your account',
        SUCCESS: 'Your account has been successfuly registered.',
      },
      INPUT: {
        EMAIL: 'Email',
        FULLNAME: 'Full Name',
        PASSWORD: 'Password',
        CONFIRM_PASSWORD: 'Confirm Password',
        USERNAME: 'Username',
        USERNAME_OR_EMAIL: 'Username or Email',
        SELECT_TENANT: 'Select Organization',
      },
      VALIDATION: {
        INVALID: '{{name}} is not valid',
        REQUIRED: '{{name}} is required',
        MIN_LENGTH: '{{name}} minimum length is {{min}}',
        AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
        NOT_FOUND: 'The requested {{name}} is not found',
        INVALID_LOGIN: 'The login details are incorrect',
        REQUIRED_FIELD: 'Required field',
        MIN_LENGTH_FIELD: 'Minimum field length:',
        MAX_LENGTH_FIELD: 'Maximum field length:',
        INVALID_FIELD: 'Field is not valid',
      },

      MESSAGES: {
        INVALID_EMAIL: 'Please enter a valid email.',
        INVALID_USERNAME_OR_EMAIL: 'Please enter your username or email.',
        INVALID_TENANT: 'Please select an organization.',
        INVALID_PASSWORD: 'Invalid or incomplete password entered.',
        INVALID_CREDENTIALS: 'The email or password is incorrect.',
        SESSION_CHANGED:
          'Your session information changed in another tab. Please sign in again.',
        PASSWORD_RESET_SUCCESS: 'Your password has been changed successfully.',
        PASSWORD_CREATED_SUCCESS:
          'Your new password has been created successfully.',
        GENERIC_ERROR: 'Sorry, some errors were detected, please try again.',
      },
      OTP: {
        TITLE: 'Two-Factor Verification',
        SUBTITLE: 'Enter the verification code sent to your email address.',
        CODE_LABEL: 'Verification code',
        CODE_FORMAT: 'The code must consist of digits only.',
        VERIFY: 'Verify',
        RESEND: 'Resend code',
        RESEND_IN: 'Resend available in {{seconds}}s',
        BACK_TO_LOGIN: 'Back to login',
        INVALID_CODE: 'The verification code is invalid or has expired.',
        SESSION_EXPIRED:
          'Your verification session has expired. Please sign in again.',
        TOO_MANY_REQUESTS: 'Too many attempts. Please wait and try again.',
        SENT: 'A new verification code has been sent.',
      },
    },
    ECOMMERCE: {
      COMMON: {
        SELECTED_RECORDS_COUNT: 'Selected records count: ',
        ALL: 'All',
        SUSPENDED: 'Suspended',
        ACTIVE: 'Active',
        FILTER: 'Filter',
        BY_STATUS: 'by Status',
        BY_TYPE: 'by Type',
        BUSINESS: 'Business',
        INDIVIDUAL: 'Individual',
        SEARCH: 'Search',
        IN_ALL_FIELDS: 'in all fields',
      },
      ECOMMERCE: 'eCommerce',
      CUSTOMERS: {
        CUSTOMERS: 'Customers',
        CUSTOMERS_LIST: 'Customers list',
        NEW_CUSTOMER: 'New Customer',
        DELETE_CUSTOMER_SIMPLE: {
          TITLE: 'Customer Delete',
          DESCRIPTION: 'Are you sure to permanently delete this customer?',
          WAIT_DESCRIPTION: 'Customer is deleting...',
          MESSAGE: 'Customer has been deleted',
        },
        DELETE_CUSTOMER_MULTY: {
          TITLE: 'Customers Delete',
          DESCRIPTION: 'Are you sure to permanently delete selected customers?',
          WAIT_DESCRIPTION: 'Customers are deleting...',
          MESSAGE: 'Selected customers have been deleted',
        },
        UPDATE_STATUS: {
          TITLE: 'Status has been updated for selected customers',
          MESSAGE: 'Selected customers status have successfully been updated',
        },
        EDIT: {
          UPDATE_MESSAGE: 'Customer has been updated',
          ADD_MESSAGE: 'Customer has been created',
        },
      },
    },
  },
};
